import { Calendar } from "./Calendar";

export default Calendar;
